import styled from '@emotion/styled';

const DefaultModelIndicator = styled('span')(({ theme }) => ({
  marginLeft: 12,
  padding: '2px 6px',
  fontSize: 14,
  color: theme.palette.getContrastText(theme.palette.primary.main),
  backgroundColor: theme.palette.primary.main,
  borderRadius: 6,
}));

export default DefaultModelIndicator;
